/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type { FindBusinessRelationshipsQueryResponse } from "../types/FindBusinessRelationships.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findBusinessRelationshipsQueryKey = () =>
  [{ url: "/v1/business-relationship/find-business-relationships" }] as const

export type FindBusinessRelationshipsQueryKey = ReturnType<
  typeof findBusinessRelationshipsQueryKey
>

/**
 * @summary Find business relationships for current organization
 * {@link /v1/business-relationship/find-business-relationships}
 */
export async function findBusinessRelationships(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindBusinessRelationshipsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/business-relationship/find-business-relationships`,
    ...requestConfig,
  })
  return res
}

export function findBusinessRelationshipsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findBusinessRelationshipsQueryKey()
  return queryOptions<
    ResponseConfig<FindBusinessRelationshipsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindBusinessRelationshipsQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findBusinessRelationships({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find business relationships for current organization
 * {@link /v1/business-relationship/find-business-relationships}
 */
export function useFindBusinessRelationships<
  TData = ResponseConfig<FindBusinessRelationshipsQueryResponse>,
  TQueryData = ResponseConfig<FindBusinessRelationshipsQueryResponse>,
  TQueryKey extends QueryKey = FindBusinessRelationshipsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindBusinessRelationshipsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findBusinessRelationshipsQueryKey()

  const query = useQuery(
    {
      ...findBusinessRelationshipsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
